import React, { useState } from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import styles from "./QuipStock.module.scss";  
import QuipStockPick from "./QuipStockPick";
import { qtyToast } from "../NotificationToast";
function QuipStock({ checker, setChecker, data, values }) {
   
  const [rider, setRider] = useState(false);
  const [list, setList] = useState(data);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleModalClose = () => {
    setChecker(false);
  };

 
  const handleCheckboxChange = (item) => {
    setSelectedRows((prev) => {
      const isSelected = prev.some((row) => row.id === item.id);

      if (isSelected) {
        return prev.filter((row) => row.id !== item.id);
      } else {
        const selectedItem = list.find((row) => row.id === item.id);
        return [...prev, selectedItem];
      }
    });
  };

  const handleReturnCountChange = (id, value) => {
    // Update the main list
    const updatedList = list.map((item) =>
      item.id === id
        ? {
            ...item,
            return_count: value,
          }
        : item
    );
    setList(updatedList);

    // Update selectedRows if the item is selected
    setSelectedRows((prev) =>
      prev.map((row) =>
        row.id === id
          ? {
              ...row,
              return_count: value,
            }
          : row
      )
    );
  };

  const handleSubmit = () => {
    console.log("Selected Rows:", selectedRows); // Debugging purpose
    setChecker(false);
    setRider(true);
  };  
  return (
    <>
      <Dialog open={checker} onClose={handleModalClose}>
        <DialogContent style={{ paddingBottom: "0" }}>
          <>
            {list?.length > 0 ? (
              list.map((item, index) => (
                <div key={index} className={styles.modalContainer}>
                  <div className={styles.box}>
                    <div className={styles.content}>
                      <div className={styles.checkbox}>
                        <input
                          type="checkbox"
                          checked={selectedRows.some(
                            (row) => row.id === item.id
                          )}
                          onChange={() => handleCheckboxChange(item)}
                        />
                      </div>
                      <div className={styles.id}>
                        <div className={styles.title}>ID</div>
                        <div className={styles.text}>{item?.id}</div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.box}>
                    <div className={styles.id}>
                      <div className={styles.title}>Brand</div>
                      <div className={styles.text}>{item?.brand}</div>
                    </div>
                  </div>
                  <div className={styles.box}>
                    <div className={styles.id}>
                      <div className={styles.title}>Name</div>
                      <div className={styles.text}>{item?.name}</div>
                    </div>
                  </div>
                  <div className={styles.box}>
                    <div className={styles.id}>
                      <div className={styles.title}>Quantity</div>
                      <div className={styles.text}>{item?.quantity}</div>
                    </div>
                  </div>
                  <div className={styles.box}>
                    <div className={styles.id}>
                      <div className={styles.title}>Return</div>
                      <div>
                        <input
                          type="number"
                          name="return_count"
                          id="return_count"
                          value={
                            item.return_count !== null &&
                            item.return_count !== undefined
                              ? item.return_count
                              : ""
                          }
                          onChange={(e) => {
                            const value = Number(e.target.value);
                            if (value > item.quantity) {
                              qtyToast();
                              return;
                            }
                            handleReturnCountChange(item.id, value);
                          }}
                          style={{ width: "50px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div>
                <p>No items found.</p>
              </div>
            )}
          </>
        </DialogContent>

        <DialogActions style={{ paddingRight: "49px", paddingBottom: "49px" }}>
          <button
            style={{
              cursor: "pointer",
              color: "#ffffff",
              backgroundColor:
                selectedRows.length === 0 ? "#DFE1E6" : "#B70303",
              padding: "10px",
              borderRadius: "3px",
              border: "1px solid #DFE1E6",
              fontSize: "14px",
            }}
            onClick={handleSubmit}
            disabled={selectedRows.length === 0}
          >
            {"Proceed"}
          </button>
        </DialogActions>
      </Dialog>

      <QuipStockPick
        rider={rider}
        setRider={setRider}
        details={data}
        values={values}
        selectedRows={selectedRows}
      />
    </>
  );
}

export default QuipStock;
